import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import StyledFormControl from '../StyledComponents/StyledFormControl';

const ITEM_HEIGHT = 340;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT + ITEM_PADDING_TOP
    },
    disableportal: 'true'
  }
};

const StyledSelect = ({ id, labelId, value, setValue, optionsList, isDisabled = false, disabledcolor = '' }) => {
  const handleChange = (event) => {
    let foundedValue = optionsList.find((value) => value.label === event.target.value);
    setValue({ ...foundedValue });
  };

  let labels = optionsList.map((value) => value.label);

  return (
    <StyledFormControl disabledcolor={disabledcolor} fullWidth>
      <Select
        disabled={isDisabled}
        id={id}
        labelId={labelId}
        value={value.label}
        onChange={handleChange}
        displayEmpty
        MenuProps={{ disableportal: true, autoFocus: false }}
        disableportal={'true'}
      >
        {labels.map((option, index) => (
          <MenuItem key={option + index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};
export default StyledSelect;
